<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-terminated',
    }"
  >
    <h4 class="mt-6 mb-9">
      Your Demo is on Hold
    </h4>
    <p class="p3">
      Hi {{ firstName }}, please check your email for additional information about your
      Datapeople account eligibility.
    </p>
  </WizardContent>
</template>

<script>
import WizardContent from '@/components/shared/WizardContent.vue';
import { mapState } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'DemoRequestHold',
  components: {
    WizardContent,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useWizard, ['firstName']),
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Demo Request Hold' });
  },
};
</script>
